import Vue from 'vue'

class MailEventRepository {

  controller = {}

  search(data, instanceId = 'default') {
    return new Promise((resolve, reject) => {

      if(this.controller[instanceId]) {
        this.controller[instanceId].abort()
      }
      this.controller[instanceId] = new AbortController()

      Vue.auth.fetch({
        url: '/api/mail-event/search',
        method: 'post',
        data,
        signal: this.controller[instanceId].signal,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  get(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/mail-event/get/' + id,
        method: 'get',
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }
}

export default new MailEventRepository()
